import { Input } from '@angular/core'
import { Component } from '@angular/core'
import { faPlus, faPencil, faXmark, faCopy, faCheck, faEraser } from '@fortawesome/free-solid-svg-icons'
import { Grid } from '../../utility/grid'
import { NgIf } from '@angular/common'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'action-toolbar-buttons',
    templateUrl: './action-toolbar-buttons.component.html',
    standalone: true,
    imports: [NgIf, FaIconComponent],
})
export class ActionToolbarButtonsComponent {
    faPlus = faPlus
    faPencil = faPencil
    faXmark = faXmark
    faCopy = faCopy
    faCheck = faCheck
    faEraser = faEraser

    @Input() addText = 'Add'
    @Input() deleteText = 'Delete'
    @Input() canEdit = false
    @Input() grid!: Grid<any>
    @Input() showAdd = false
    @Input() showEdit = false
    @Input() showDelete = false
    @Input() showDuplicate = false
    @Input() customAddText = ''
    @Input() customDeleteText = ''
    @Input() customActionComponent: any
}
